var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "d-flex align-items-center justify-content-center px-1 bg-warning",
    },
    [
      _c("p", { staticClass: "py-1 mb-0 me-1" }, [
        _c("strong", { domProps: { innerHTML: _vm._s(_vm.text) } }),
      ]),
      _vm._v(" "),
      _c("OverlayDialog", {
        attrs: {
          id: "discount-info-overlay",
          "modal-button-label": "Retour",
          "action-label": "test",
          "tms-category": _vm.overlay.tms.category,
          "tms-action": _vm.overlay.tms.action,
          "tms-label": _vm.overlay.tms.label,
          "modal-title": _vm.overlay.title,
          "html-content": _vm.overlay.content,
          "is-action-button": false,
          "is-icon-button": true,
          "icon-name": "icon-info-alt",
          "aria-label": "En savoir plus sur la remise",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }